// @ts-nocheck
import { MakesyQuantitySelector } from "//makesy.com/cdn/shop/t/440/assets/QuantitySelector.js?v=78040802197185606151746795536";
import { getBulkDiscounts } from "//makesy.com/cdn/shop/t/440/assets/getBulkDiscounts.js?v=144928991031589561581793196097";
import { addToCart, QuickBuyDrawer } from "//makesy.com/cdn/shop/t/440/assets/theme.js?v=95843797919787098341792064552";


const MakesyQuickAddButtons  = class extends HTMLElement {
    elements = {
        submitBTN: this.querySelector('.add-to-cart'),
        messages: this.getElementsByClassName('Product__messaging')[0],
        prices: this.closest('quick-buy-drawer')?.querySelectorAll('sale-price, compare-at-price'),
        optionTitlesElements: Array.from(this.closest('quick-buy-drawer').querySelectorAll('.variant-picker variant-option-value'))
    }
    constructor() {
        super();
        this.state = {
            metafields: metafields,
            variantMetafields: variantMetafields,
            product: product,
            currentVariant: product.variants[0],
            variantOutOfStock: false
        }
        console.log('this.state:', this.state)
       this.count = 0
    }
    connectedCallback() {
        this._abortController = new AbortController();
        MakesyQuantitySelector.prototype.updaters = [this.updatePrice.bind(this), this.updateBulkDiscountMessage.bind(this)] 
        if (!window.customElements.get("makesy-quantity-selector")) {
            window.customElements.define("makesy-quantity-selector", MakesyQuantitySelector);
        }

        /* Connected callback runs more then once, this runs only once */
        if(this.count++ === 0) {
            this.loader = new Loading({
                containerElement: this.querySelector('button.add-to-cart'),
                count: 7,
                circleSize: 13,
                color: '#969696',
                width: '125px'
            })
            this.getVariant()
            // Variant selector
            this.closest('quick-buy-drawer')?.querySelector('variant-picker').addEventListener('click', e => e.target.tagName === 'INPUT' && this.updateProduct(this.getVariant(), e?.target))
            // Add to quick buy modal
            this.elements.submitBTN.addEventListener('click', this.addToCart.bind(this))
        }
    }

    async addToCart(e) {
        e.stopImmediatePropagation()
        this.loader.initRotate()
        const quantity = document.querySelector('.QuantitySelector input[name="quantity"]').value
        const cartSectionId = document.querySelector("#cart-drawer").parentNode.id.replace(/shopify-section-/, '')
        const {currentVariant, product, metafields} = this.state
        try {
            const payload = {
                sections_url: `/variants/${currentVariant.id}`,
                sections: ['variant-added', cartSectionId],
                items: [{
                    properties: {item_weight: currentVariant.weight},
                    id: currentVariant.id,
                    quantity
                }]
            }
            const selectedSellingPlanInput = document.querySelector('input[name="selling_plan"]')
            const selectedSellingPlanId = selectedSellingPlanInput ? selectedSellingPlanInput.value : ''
            if (selectedSellingPlanId) {
                payload.items[0].selling_plan = selectedSellingPlanId
            }
            
            /* Bulk Discounts for non Wicks */
            console.log('quantity, this.state:', quantity, this.state)
            const bulkDiscounts = getBulkDiscounts(quantity, this.state)
            if (bulkDiscounts && bulkDiscounts.has_bulk_discounts !== 'show_regular_price') {
                payload.items[0].properties = {...payload.items[0].properties, ...{ _percent: bulkDiscounts.percent.toString(), _quantity: bulkDiscounts.quantity.toString() }}
            }
            const json = await addToCart(payload)

            // If cart Error run message 
            if (json.status) {
                console.log('cart error status:', json.description)
                this.elements.messages.classList.add('--error')
                this.elements.messages.textContent = json.description
                
                // Even on error, fetch updated cart to sync the cart icon and cart drawer
                // This handles cases where maximum quantity was added despite the error
                try {
                    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
                    
                    // Fetch cart drawer section to update the drawer content
                    const sectionsResponse = await fetch(`${Shopify.routes.root}?sections=${cartSectionId}`);
                    const sectionsData = await sectionsResponse.json();
                    
                    // Add sections data to cart content for drawer update
                    cartContent["sections"] = sectionsData;
                    
                    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                        bubbles: true,
                        detail: {
                            baseEvent: "cart:error",
                            cart: cartContent
                        }
                    }));
                } catch (cartFetchError) {
                    console.log('Error fetching cart after add error:', cartFetchError);
                }
            } else {
                const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
                cartContent["sections"] = json["sections"];
                const cartDrawer = this.closest('quick-buy-drawer')
                // Updates the quick drawer
                cartDrawer.dispatchEvent(new CustomEvent("variant:add", {
                    bubbles: true,
                    detail: {
                        items: json.hasOwnProperty("items") ? json["items"] : [json],
                        cart: cartContent
                    }
                }));
                // Updates the cart
                document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                    bubbles: true,
                    detail: {
                        baseEvent: "variant:add",
                        cart: cartContent
                    }
                }));
            }
            this.loader.clearRotation()
        } catch (error) {
            console.log('cart error:', error)
            this.elements.messages.classList.add('--error')
            this.elements.messages.textContent = typeof json === 'undefined' ? error : json.description ?? error
            
            // Even on error, fetch updated cart to sync the cart icon and cart drawer
            try {
                const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
                
                // Fetch cart drawer section to update the drawer content
                const sectionsResponse = await fetch(`${Shopify.routes.root}?sections=${cartSectionId}`);
                const sectionsData = await sectionsResponse.json();
                
                // Add sections data to cart content for drawer update
                cartContent["sections"] = sectionsData;
                
                document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                    bubbles: true,
                    detail: {
                        baseEvent: "cart:error",
                        cart: cartContent
                    }
                }));
            } catch (cartFetchError) {
                console.log('Error fetching cart after add error:', cartFetchError);
            }
            
            this.loader.clearRotation()
        }
    }

    updatePrice(quantity = this.querySelector('.QuantitySelector input[name="quantity"]').value, variant=this.state.currentVariant) {
        const price =  variant.price
        const { index, percent, threshHoldMet} = getBulkDiscounts(quantity, this.state);
        const bulkDiscountPercent = threshHoldMet ? percent[index] : 0;
        this.elements.prices.forEach(el => {
            if(el.id == 'compare-at') {
                if(variant.compare_at_price === null) return el.innerText = '';
                el.innerText = '$'+(variant.compare_at_price / 100 * quantity).toFixed(2)
            } else {
                el.innerText = '$'+((price / 100 * quantity) * ((100-bulkDiscountPercent)/100)).toFixed(2)
            }
        })
    }

    updateOptionTitles(variant, target) {
        const targetNameAttribute = target.getAttribute('name')
        const matchingTitleEl = this.elements.optionTitlesElements.find(el => el.getAttribute('for') == targetNameAttribute)
        matchingTitleEl.textContent = target.value
    }

    getVariant() {
        const checkedOptions = this.closest('quick-buy-drawer')?.querySelectorAll('variant-picker input:checked')
        const titleValue =  Array.from(checkedOptions).map(el => el.value).join(' / ');
        const variant = this.state.product.variants.find(variant => variant.title === titleValue)
        if(!variant) console.log('variant:', variant);
        this.state.currentVariant = variant ? variant : this.state.currentVariant
        return this.state.currentVariant
    }

    checkAvailability(variant) {
        if(!variant.available) {
            this.elements.submitBTN.children[0].textContent = 'sold out'
            this.elements.submitBTN.children[0].style.color = '#000'
            this.elements.submitBTN.style.pointerEvents = 'none'
            this.elements.submitBTN.style.backgroundColor = '#EEECEB'
            return this.state.variantOutOfStock = true
        }
        if(this.state.variantOutOfStock) {
            this.elements.submitBTN.style.pointerEvents = null
            this.elements.submitBTN.style.backgroundColor = null
            this.elements.submitBTN.children[0].textContent = 'add to cart'
            this.elements.submitBTN.children[0].removeAttribute('style')
            this.state.variantOutOfStock = false
        }
    }

    updateProduct(variant, target) {
        this.updatePrice()
        this.updateBulkDiscountMessage()
        this.checkAvailability(variant)
        this.updateOptionTitles(variant, target)
    }

    /**
    * @param {String} className The class name of the message to remove. If no class name supplied it will remove any class name and message
    */
    removeMessage(className = false) {
        const messageState = this.elements.messages.classList.contains(className)
        if (messageState) {
            this.elements.messages.textContent = ''
            this.elements.messages.classList.remove(className)
        } else {
            this.elements.messages.textContent = ''
            this.elements.messages.className = 'Product__messaging'
        }
    }

    /**
    * @param {String} className The class name to add. Either --message or --error
    * @param {String} message The message you wish to add
    */
    updateMessage(className, message) {
        this.elements.messages.className = `Product__messaging ${className}`
        this.elements.messages.textContent = message
    }

    updateBulkDiscountMessage(selected_quantity = this.querySelector('.QuantitySelector input[name="quantity"]').value) {
        if (!selected_quantity) return;
        let { index, percent, quantity, threshHoldMet, hideMessage } = getBulkDiscounts(selected_quantity, this.state)
        if (index === undefined || hideMessage) return this.removeMessage();
        const title = this.state.currentVariant.title
        const nextTierQuantity = quantity[index + 1] - selected_quantity
        const exactQuantity = (quantity[index] - selected_quantity) == 0

        let message = ''
        if (exactQuantity) {
            message = `You qualify for ${percent[index]}% off ${title}`
        } else if (!threshHoldMet) {
            message = `Add ${(quantity[0] || quantity[1]) - selected_quantity} more for ${percent[index]}% off ${title}`
        } else if (isNaN(nextTierQuantity)) {
            message = `You qualify for ${percent[index]}% off ${title}`
        } else { 
            message = `You qualify for ${percent[index]}% off ${title}. 
            Add ${nextTierQuantity} more for ${percent[index + 1]}% off`
        }
        this.updateMessage('--message', message)
    }

    
    disconnectedCallback() {
        this._abortController.abort();
    }   
}

if (!window.customElements.get("makesy-quick-add-buttons")) {
    window.customElements.define("makesy-quick-add-buttons", MakesyQuickAddButtons);
}
